import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { Book, Heart, Sparkles, ChevronDown } from 'lucide-react';

const Hero = ({ onStartClick }) => {
  const { t } = useTranslation();
  return (
    <div className="hero-gradient min-h-screen flex flex-col items-center justify-center px-4 py-20 relative">
      <div className="max-w-4xl mx-auto text-center fade-in">
        <div className="flex justify-center gap-5 mb-8">
          <div className="float-animation"><Book className="w-7 h-7 text-purple-400/80" /></div>
          <div className="float-animation" style={{ animationDelay: '0.5s' }}><Heart className="w-7 h-7 text-pink-400/80" /></div>
          <div className="float-animation" style={{ animationDelay: '1s' }}><Sparkles className="w-7 h-7 text-amber-400/80" /></div>
        </div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 leading-tight tracking-tight" data-testid="hero-title">
          <span className="bg-gradient-to-r from-pink-500 via-rose-400 to-purple-500 bg-clip-text text-transparent">Life Echo</span>
        </h1>
        <p className="text-base sm:text-lg lg:text-lg text-gray-700 font-medium mb-3 tracking-wide">{t('hero.tagline')}</p>
        <p className="text-base text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed">{t('hero.subtitle')}</p>
        <div className="space-y-4">
          <Button size="lg" onClick={onStartClick} className="btn-primary text-white px-10 py-6 text-base font-semibold rounded-full shadow-lg border-0" data-testid="start-my-story-btn">{t('hero.cta')}</Button>
          <p className="text-sm text-gray-500">{t('hero.noSkills')}</p>
        </div>
        <div className="mt-16 flex flex-wrap justify-center gap-8 text-sm text-gray-500 stagger-children">
          <div className="flex items-center gap-2 fade-in"><Sparkles className="w-4 h-4 text-amber-400" /><span>{t('hero.aiPowered')}</span></div>
          <div className="flex items-center gap-2 fade-in"><Book className="w-4 h-4 text-purple-400" /><span>{t('hero.wordCount')}</span></div>
          <div className="flex items-center gap-2 fade-in"><Heart className="w-4 h-4 text-pink-400" /><span>{t('hero.keepForever')}</span></div>
        </div>
      </div>
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce opacity-40"><ChevronDown className="w-6 h-6 text-gray-500" /></div>
    </div>
  );
};
export default Hero;
